/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

let $ = jQuery;

//###################
/* PHOTO EDITOR */
//###################

window.PhotoEditor = {
	// Mark as true to disable the editing process
	disabled: false,

	// A flag to turn on and off captioning
	captionsDisabled: false,

	// Photo info object
	photo: null,

	// Crop info
	maxWidth: 720,

	maxHeight: 480,

	init() {
		this.editContainer = $("#okphotos_edit");
		this.editWrapper = $("#okphotos_edit_wrapper");
		this.detailsForm = new OkForm("okphotos_edit_actions");
		this.caption = $("#photo_caption");
		this.photoEl = $("#okphotos_photo");
		this.photoFrame = $("#okphotos_frame");
		this.nextBtn = $("#okphotos_edit_next");
		this.cancelBtn = $("#okphotos_edit_cancel");

		this.nextBtn.on("click tap", () => {
			if (!this.captionsDisabled) {
				if (this.state == "crop") {
					this.changeState("caption");
					this.cropper.disable();
					return;
				}
			}

			// Sometimes there's an upload error (e.g. size too small),
			// That seems to cause this to fail, so bail out.
			if (!this.cropper) {
				return;
			}

			this.cropper.disable();

			PhotoUploader.uploadDetails({
				picid: this.photo.id,
				width: this.photo.width,
				height: this.photo.height,
				crop: this.cropper.output(),
				caption: this.caption.val(),
				newPhoto: 1,

				cb: (response, data) => {
					if (response.error) {
						OkPhotos.showError(response.error);
					} else {
						this.finishedCallback(response, data);
					}
				},
			});
		});

		this.changeState("crop");
		this.initialized = true;
	},

	// Initialize the simplecropper.
	initCrop() {
		this.photoEl.simpleCrop(OkPhotos.cropSettings);
		this.cropper = this.photoEl.data("simplecrop");
	},

	// Change the editors state
	changeState(state) {
		if (this.state) {
			this.editContainer.removeClass(this.state);
		}

		if (this.state === "crop") {
			if (this.cropper) {
				this.cropper.enable();
			}
		} else if (this.state === "caption") {
			this.caption.val("");
		}

		this.state = state;
		this.editContainer.addClass(this.state);
	},

	// Photos should be structured as such:
	//	id	(string) - Unique ID of the photo
	//	url (string) - URL of the photo.
	//	width	 (int) - Numeric width of photo.
	//	height (int) - Numeric height of the photo.
	loadPhoto(photo, cb, errCb) {
		this.photo = photo;

		// Clear out the wrapper
		this.editWrapper.html("");
		this.editWrapper.append(this.photoEl);

		// Size and center the frame on load.
		this.photoEl.unbind("load").on("load", () => {
			this.maxHeight = this.editWrapper.height();
			this.maxWidth = this.editWrapper.width();

			// Fire the callback if provided
			if (cb) {
				return cb();
			}
		}).on("error", function (error) {
			console.error(error);

			if (errCb) {
				return errCb(error);
			}
		});

		// Actually load it in.
		this.photoEl.attr("src", photo.url);
	},

	// Call when finished. Handles the final actions.
	finishedCallback(response, data) {
		this.photo.crop = this.cropper.output();
		this.photo.path =
			`${this.photo.crop.left}x${this.photo.crop.top}/` +
			this.photo.crop.right +
			"x" +
			this.photo.crop.bottom +
			"/2/" +
			this.photo.id +
			".jpg";

		if (data && data.caption) {
			this.photo.caption = data.caption;
		}

		// square image
		this.photo.square = response.large_thumb_url;

		PhotoFinished.uploadCallback(this.photo);
	},
};



// WEBPACK FOOTER //
// ./src/legacy/okphotos/photoeditor.js